import type { Lut } from '@mimir/common/types/lut';
import { api_getLuts } from '../api/lutsApi';
import type { BasicFetch } from '@mimir/common/types/basicFetch';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { createDefaultGetLuts } from '@mimir/common/util/createDefaultGetLuts';

export function createDefaultGetLutsFromBackendClient(
  services: {
    backendClient: BackendClient,
    fetch: BasicFetch,
  }
): (() => Promise<Lut[]>) {
  return createDefaultGetLuts(
    async () => { return api_getLuts(services.backendClient); },
    services.fetch,
  );
}

